import React from "react";
import uniqueId from "lodash/uniqueId";
import { Button } from "../styled";

/**
 * ArrayAddButton component for adding items to a Formik FieldArray.
 * @param {Object} props
 * @param {Object} props.arrayHelpers - Formik FieldArray helpers.
 * @param {Array} props.dataArray - The current array of items.
 * @param {Object} props.addedItem - The item to add.
 * @param {number} props.limit - Maximum allowed items.
 * @param {Array} props.requiredFields - Required fields for validation.
 */
export const ArrayAddButton = ({
  arrayHelpers,
  dataArray,
  addedItem,
  limit,
  requiredFields,
  ...props
}) => {
  const checkIsAddButtonDisabled = () => {
    if (!dataArray.length) {
      return false;
    }
    return dataArray.length === limit;
  };

  return (
    <Button
      onClick={() => arrayHelpers.insert(dataArray.length, { ...addedItem, id: uniqueId() })}
      disabled={checkIsAddButtonDisabled()}
      {...props}
    />
  );
};
